export const environment = {
    name: 'dev',
    apiEndpoint: 'https://gui8l0m0h4.execute-api.us-east-1.amazonaws.com/prod',
    authCookieExpireDays: 30,
    paymentServiceLink: 'https://venmo.com/?txn=pay&recipients={username}&amount=25&note={tag}',
    paymentServiceUsername: 'John-Strawn-6'
}